import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import News from './News/News';
import withAuth from './../auth_components/js/withAuth';
import DashBoard from './DashBoard';
import MenuBar from './HeaderComponents/MenuBar';
class MainHome extends Component {
  render() {
    return (
            <div>
              <DashBoard history={this.props.history} user={this.props.user} />
              <MenuBar />
              Home
            </div>
    )
  }
}

export default withAuth(MainHome);



// WEBPACK FOOTER //
// ./src/HomeComponents/MainHome.js